<div class="modal-header">
  <h3 class="modal-title text-color-primary"
      data-cy="confirm-modal-title">
    {{ title | translate }}
  </h3>
  <button type="button" class="btn-close" aria-label="Close" (click)="reject()"></button>
</div>
<div class="modal-body">
      <pre class="confirm-modal-text"
           style="overflow-x: auto;
                  white-space: pre-line;
                  white-space: -moz-pre-wrap;
                  white-space: -o-pre-wrap;
                  word-wrap: break-word;"
           [innerHTML]="this.text"
      >
      </pre>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-cy="modal-cancel-btn" (click)="reject()">{{ nobuttontext }}</button>
    <button type="button" class="btn btn-primary" data-cy="modal-submit-btn"  (click)="accept()">{{ yesbuttontext }}</button>
  </div>
